export interface TsAppVersion {
    version: string;
    name: string;
    description?: string;
    versionLong?: string;
    versionDate: string;
    gitCommitHash?: string;
    gitCommitDate?: string;
    gitTag?: string;
};
export const versions: TsAppVersion = {
    version: '2.6.0',
    name: 'fpar',
    versionDate: '2026-02-10T16:03:32.448Z',
};
export default versions;
